// import styles from './InformationFormsStyle.module.scss'
import FullAddressField from "../ReusableComponent/FullAddress"
import AddressField from "../ReusableComponent/AddressField"
import EmployerField from "../ReusableComponent/EmployerField"
import FormButtons from "./FormButtons"
import React, { useState, useEffect } from "react";
import { baseUrl } from "../../common/constants"
import { toast } from "react-toastify";
import { mainContext } from "../../context/context";
import _axios from "../../utils/api/_axios"
import { EditOutlined } from "@ant-design/icons"
import { Content } from "antd/es/layout/layout"
import { Col, Row, Typography } from "antd"
import { useParams } from 'react-router-dom'
import { getAdminToken } from '../../utils/helpers'
import { EmployeeInformationSchema, validateField } from './Validations/FormsValidations'


const EmployerForm = ({ isForm = true, patientId="", claim = {},fetchClaims,setSelectedClaim}) => {
    const token = getAdminToken()
    const { currentTab, activeTab, formDataValues, getFormData,errors, setErrors } = React.useContext(mainContext)
    const { id } = useParams();
    const route = `/new-entry/details/${id}`
    const [isEditing, setIsEditing] = React.useState(true);
    const [message, setMessage] = useState("");
    const [isDisable,setIsDisable] = useState(false)
    const [formValues, setFormValues] = useState({ company: "", companyPhone: "", employer_address1: "", employer_address2: "", employer_city: "", employer_state: "", employer_zip: "" });
    
    const inputChangeHandler = (event) => {
        const { name, value } = event.target
        setFormValues({ ...formValues, [name]: value })

        const errorMessage = validateField(name, value, EmployeeInformationSchema);
        setErrors({ ...errors, [name]: errorMessage });

        getFormData({
            ...formDataValues,
            employeeInfo: {
                ...formDataValues.employeeInfo,
                [name]: value
            }
        });
    }

    const map = (formValues) => {
        return {
            "updateProperty": "employerDetails",
            "value": {
                "company": formValues.company,
                "companyPhone": formValues.companyPhone,
                "employer_address1": formValues.employer_address1,
                "employer_address2": formValues.employer_address2,
                "employer_city": formValues.employer_city,
                "employer_state": formValues.employer_state,
                "employer_zip": formValues.employer_zip
            }
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsDisable(true);
        const { error } = EmployeeInformationSchema.validate(formValues, { abortEarly: false });
        let claimId = sessionStorage.getItem("claimId");
        if(!patientId) {
            patientId = sessionStorage.getItem("patientId");
        }
        if (patientId && claim?._id) {
            claimId = claim?._id;
        }
        if (error) {
            const errorMessages = error.details.reduce((acc, detail) => {
              acc[detail.path[0]] = detail.message;
              return acc;
            }, {});
            setErrors(errorMessages);
            setIsDisable(false);
          }
          else{
            setErrors({})
            if (patientId && claimId) {
                try {
                    let res = await _axios.put(`${baseUrl}/patients/${patientId}/claims/${claimId}`, map(formValues), {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        cache: "no-cache"
                    });
                    let resJson = res.data;
                    if (res.status === 200) {
                        toast("Successfully saved patient.", {
                            type: "success",
                            autoClose: 3000,
                        });
                        setIsDisable(false);
                        currentTab(2);
                        if (!isForm) {
                            setIsEditing(false);
                        }
                        if(window.location.pathname === `/patient-info/${id}`){
                          // const response = fetchClaims(patientId);
                          // setSelectedClaim(response?.data?.payload?.find(claim => claim._id === claimId))
                          window.location.reload();
                        }
                    } else {
                        toast("Unable to submit. Some error occured", {
                            type: "error",
                            autoClose: 3000,
                        });
                    }
                } catch (err) {
                    console.log(err);
                }
            }
          }      
    }

    const setValues = (payload) => {
        setFormValues({
            "company": payload.company,
            "companyPhone": payload.companyPhone,
            "employer_address1": payload.employer_address1,
            "employer_address2": payload.employer_address2,
            "employer_city": payload.employer_city,
            "employer_state": payload.employer_state,
            "employer_zip": payload.employer_zip
        })
    }

    let fetchInitial = async (patientId, claim) => {
        let claimId = sessionStorage.getItem("claimId");
        if(!patientId) {
            patientId = sessionStorage.getItem("patientId");
        }
        if (patientId && claim?._id) {
            claimId = claim?._id;
            return claim.employerDetails;
        }
       // todo pankaj, this code will never be called, we can remove this
        if (patientId && claimId) {
            try {
                let res = await _axios.get(`${baseUrl}/patients/${patientId}/claims/${claimId}`, {
                    params: {
                        title: 'employerDetails'
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                if (res.status === 200) {
                    return res.data.payload;
                } else {
                    toast.error("Error fetching initial data");
                }
            } catch (err) {
                console.log(err);
            }
        } else {
            (token && (window.location.pathname !== route && window.location.pathname !== '/open-access-patient')) && toast.warn("Please save the patient before adding any information to claim")
        }
    }

    let fetchSelectedEmployee = async (patientId = "") => {
          if (patientId || id) {
          try {
            const URL = window.location.pathname === route ? `${baseUrl}/openAccess/${id}` : `${baseUrl}/patients/${patientId}`
            const response = await _axios.get(URL);
            let renderResponse = window.location.pathname === route ? response.data?.payload?.employeeInfo : response.data?.payload
            if (response.status === 200) {
              // TODO pankaj, remove all irrelevant set messages and use toast message
              setMessage("User created successfully");
            } else {
              setMessage("Some error occured");
            }
            return renderResponse;
          } catch (err) {
            console.log(err);
          }
          }
      };
    
      const setEmployeeValues = (patient) => {
        const formPayload = { ...patient, patientId: patient?._id }
        setFormValues(mapAPIDataToFormData(formPayload));
      };

    const handleClose = () => {
        if (!isForm) {
            setIsEditing(false);
        }
    }

    const mapAPIDataToFormData = (payload) => {
        return {
          patientId: payload?.patientId,
          company:payload.company,
          companyPhone: payload.companyPhone,
          employer_address1: payload.employer_address1,
          employer_address2: payload.employer_address2,
          employer_city: payload.employer_city,
          employer_state: payload.employer_state,
          employer_zip: payload.employer_zip
      }
    }

    useEffect(() => {
        setIsEditing(isForm);
        fetchSelectedEmployee().then((payload) => {
            if (payload){
                setEmployeeValues(payload)
            };
          });
          if(patientId && claim){
            fetchInitial(patientId, claim).then((payload)=>{
               if(payload){
                setValues(payload)
              }
              })    
          }    
           
    },[])

    const handleEditing = () => {
        setIsEditing(true);
        fetchInitial(patientId, claim).then((payload)=>{
          if(payload){
            setValues(payload);
          }
        })  
    }

      const formsRender=()=>{
        return (
            <form 
            className={`w-full p-4 mb-8 ${isEditing ? "bg-gray-100 rounded-lg shadow-md" : "bg-white border border-gray-300 rounded-lg"}`} 
            onSubmit={handleSubmit}
          >
            {/* Header Section */}
            <div className="flex justify-between items-center bg-gray-600 text-white p-3 rounded-t-lg">
              <Typography.Title className="text-white text-lg" level={5}>Employer Information</Typography.Title>
              {!isEditing && (
                <div className="flex items-center space-x-2">
                  <div className="cursor-pointer text-white hover:text-gray-200" onClick={handleEditing}>
                    <EditOutlined className="text-xl" />
                  </div>
                </div>
              )}
            </div>
          
            {/* Form Fields Section */}
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-300">
  <div className="p-4 border-t border-gray-300">
    <EmployerField 
      onChange={(e) => inputChangeHandler(e)} 
      formValues={formValues} 
      isForm={isEditing} 
      errors={errors} 
      employerInfo={claim.employerDetails}
    />

    <FullAddressField 
      onChange={(e) => inputChangeHandler(e)} 
      formValues={formValues} 
      isForm={isEditing} 
      errors={errors} 
      employerInfo={claim.employerDetails} 
      prefix="employer_"
    />

    <AddressField 
      onChange={(e) => inputChangeHandler(e)} 
      formValues={formValues} 
      isForm={isEditing} 
      errors={errors} 
      employerInfo={claim.employerDetails} 
      prefix="employer_"
    />

    {/* Submit & Close Buttons */}
    {isEditing && (
      <div className="mt-4">
        <div className="flex justify-end">
          <FormButtons handleClose={handleClose} isDisable={isDisable} />
        </div>
      </div>
    )}
  </div>
</div>

          </form>
          
        )
      }

      const employeeWrapper=()=>{
        const route = window.location.pathname === `/patient-info/${id}` 
        if(route){
            return <div>{formsRender()}</div>
        }
        else{
            return (
           <>{formsRender()}</>
            )
        }
        
      }

    return (
        <Content className="w-full space-y-6">
        {employeeWrapper()}
      </Content>
      
    )
}

export default EmployerForm